import React from 'react'
import MainInsuranceScheme from './Components/MainInsuranceScheme/MainInsuranceScheme'
import OptionalExtensions from './Components/OptionalExtensions/OptionalExtensions'

const CoverLinkConfigs = (props) => {
  return (
    <>
        <MainInsuranceScheme
        membership_configs={props.membership_configs}
        productGuid={props.productGuid}
      />
      <br />
      <OptionalExtensions 
        membership_configs={props.membership_configs}
        productGuid={props.productGuid}
      />
      <br />
    
    
    </>
  )
}

export default CoverLinkConfigs